import { NOTIFICATION } from 'utils/types';
import dotenv from 'dotenv';
dotenv.config();

const initialState = {
  status: false,
  message: '',
  type: '',
  link: null,
  notificationId: 0,
  description: '',
  position: 'bottom-right',
  duration: null,
  onClose: null,
  pauseOnHover: true,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case NOTIFICATION:
      return {
        ...state,
        status: payload.status,
        message: payload.message,
        type: payload.type,
        link: payload.link,
        notificationId: state.notificationId + 1,
        description: payload.description,
        position: payload.position,
        duration: payload.duration,
        onClose: payload.onClose,
        pauseOnHover: payload.pauseOnHover ?? true,
      };
    default:
      return state;
  }
}
